// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";

// function ArticleDetail() {
//   const { id } = useParams();
//   const [article, setArticle] = useState(null);

//   useEffect(() => {
//     fetch(`http://localhost:5000/api/articles/${id}`)
//       .then(res => res.json())
//       .then(data => setArticle(data));
//   }, [id]);

//   if (!article) return <p className="text-center mt-5">Loading...</p>;

//   return (
//     <div className="container mt-4">
//       <h1 className="mb-3">{article.title}</h1>
//       <p>{article.content}</p>
//     </div>
//   );
// }

// export default ArticleDetail;
// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";

// function ArticleDetail() {
//   const { id } = useParams();
//   const [article, setArticle] = useState(null);

//   useEffect(() => {
//     fetch(`http://localhost:5000/api/articles/${id}`)
//       .then((res) => res.json())
//       .then((data) => setArticle(data))
//       .catch((err) => console.error("Error fetching article:", err));
//   }, [id]);

//   if (!article) return <p className="text-center mt-5">Loading...</p>;

//   return (
//     <div className="container mt-4">
//       {/* Title */}
//       <h1 className="mb-3">{article.title}</h1>

//       {/* Category info */}
//       <p className="text-muted">
//         Category: <strong>{article.category}</strong> | Subcategory:{" "}
//         <strong>{article.subcategory}</strong>
//       </p>

//       {/* Image */}
//       {article.imageUrl && (
//         <div className="text-center mb-4">
//           <img
//             src={article.imageUrl}
//             alt={article.title}
//             className="img-fluid rounded shadow"
//             style={{
//               maxHeight: "400px",
//               objectFit: "cover",
//             }}
//           />
//         </div>
//       )}

//       {/* Content */}
//       <p style={{ lineHeight: "1.7", fontSize: "1.1rem" }}>{article.content}</p>
//     </div>
//   );
// }

// export default ArticleDetail;
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

function ArticleDetail() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    fetch(`https://movie-backend-1wmv.onrender.com/api/articles/${id}`)
      .then((res) => res.json())
      .then((data) => setArticle(data))
      .catch((err) => console.error("Error fetching article:", err));
  }, [id]);

  if (!article) return <p className="text-center mt-5">Loading...</p>;

  return (
    <div className="container mt-4">
      {/* Title */}
      <h1 className="mb-3">{article.title}</h1>

      {/* Category info */}
      <p className="text-muted">
        Category: <strong>{article.category}</strong> | Subcategory:{" "}
        <strong>{article.subcategory}</strong>
      </p>

      <div className="clearfix">
        {/* Image floated left */}
        {article.imageUrl && (
          <img
            src={article.imageUrl}
            alt={article.title}
            className="img-fluid rounded shadow me-3 mb-3 float-start"
            style={{
              width: "40%",
              maxWidth: "400px",
              height: "auto",
              objectFit: "cover",
            }}
          />
        )}

        {/* Content beside the image */}
        {/* <p style={{ lineHeight: "1.8", fontSize: "1.1rem", textAlign: "justify" }}>
          {article.content}
        </p> */}
        <div
          className="article-content"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />

      </div>
    </div>
  );
}

export default ArticleDetail;
